import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnChanges, AfterContentInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import { MatDialog } from '@angular/material/dialog';
import { CustomEditorDialogComponent } from '../custom-editor-dialog/custom-editor-dialog.component';
declare const $: any;

@Component({
  selector: 'app-custom-editor',
  templateUrl: './custom-editor.component.html',
  styleUrls: ['./custom-editor.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CustomEditorComponent, multi: true }
  ],
})

export class CustomEditorComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges, AfterViewInit {
  @Input() name: string;
  @Input() disabled: boolean = false;
  @Input() errorText: string;
  @Input() label: string;
  @Input() value: string;
  @Input() autocomplete: string = 'off';
  @Input() color: string = 'primary';
  @Input() isRequired: boolean = false;
  @Output() onchange: EventEmitter<any> = new EventEmitter<{ name: string, editorData: string }>();
  @Input() formSubmitted: boolean = false;
  @Input() formControl: any;
  @Input() index: number = 0;
  @Input() inputText: string;
  @Input() elementName: string;
  
  @ViewChild('dataContainer') dataContainer: ElementRef;

  private _maxlength;
  @Input() set maxlength(max) {
    this._maxlength = max && parseInt(max, null) || 0;
  }

  get maxlength() {
    return this._maxlength;
  }

  constructor(private cdf: ChangeDetectorRef,  private dialog?: MatDialog) {
    super();
  }

  ngOnInit() {
    try {
      this.cdf.detectChanges();

    } catch (ex) {
      throw ex;
    }
  }

  setContent() {
    if (this.inputText) {
      this.dataContainer.nativeElement.innerHTML = this.inputText;
    }

    let that = this;
    $(".editortext").click(function () {     
      let enumName = $(this).attr("title");
      const dialogRef = that.dialog.open(CustomEditorDialogComponent, {
        width: '600px',
        data: {
          enumName: enumName
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result != '') {
          $(this).text(result);
          that.dialog.closeAll();
          that.onchange.emit({ name: $(this).parent().attr("title"), editorData: $(this).parent().html() });
        }
        else {
          that.dialog.closeAll();
        }
      });
    })
  }

  ngAfterViewInit() {   
    this.setContent();
    this.cdf.detectChanges();
  }

  ngOnChanges() {
    if (this.dataContainer?.nativeElement?.innerHTML && this.dataContainer.nativeElement.innerHTML != this.inputText) {
      this.dataContainer.nativeElement.innerHTML = this.inputText;
    }
    this.cdf.detectChanges();
  }

  change() {
    try {
      this.onchange.emit({ name: this.elementName, editorData: this.dataContainer.nativeElement.innerHTML });
    } catch (ex) {
      throw ex;
    }
  }
}
